module.exports = __webpack_public_path__ + "static/media/pr-11.a6f8a791.jpeg";